import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { isAdminType, StateService } from '@services/state.service';
import { isFunction, isJsObject, unsub } from '@util/utils';
import { ICellRendererParams } from 'ag-grid-community';
import { Subscription } from 'rxjs';

export interface EditCellRendererEvent {
  type: string;
  data: any;
}

export const enum EditCellRendererEventType {
  DELETE = 'delete',
  RESTORE = 'restore',
  VIEW = 'view',
}

@Component({
  selector: 'app-edit-cell-renderer',
  template: `
  <div class="edit-cell-renderer">
  <div [ngClass]="frCls">
    <div class="download-button" *ngIf="canDownload && url">
      <a class="download-document-link"
        [href]="url"><mat-icon class="download-icon">file_download</mat-icon></a>
    </div>

    <div *ngIf="canRestore && isAdmin" class="delete-button-wrapper">
      <button mat-icon-button class="delete-button" (click)="clickRestore()" [title]="titleRestore">
        <mat-icon class="delete-icon">restore_page</mat-icon>
      </button>
    </div>
  </div>
    <div *ngIf="canEdit" class="edit-button-wrapper">
      <button mat-icon-button class="edit-button" (click)="clicked()" title="Editieren">
        <mat-icon class="edit-icon">edit</mat-icon>
      </button>
    </div>
    <div class="last-row">
    <div *ngIf="canDelete && isAdmin" class="delete-button-wrapper" style="margin-bottom: 0.75rem">
      <button mat-icon-button class="delete-button" style="padding-left:0"
       (click)="clickDelete()" [title]="titleDelete">
        <mat-icon class="delete-icon">delete</mat-icon>
      </button>
    </div>
    </div>
  </div>
`
})
export class EditCellRendererComponent implements OnInit, OnDestroy {

  id: any;

  url = '';

  isAdmin: isAdminType = false;
  canDelete = false;
  canDownload = false;
  canRestore = false;
  checkMissing = false;
  canEdit = true;
  directUrl = false;
  frCls = '';

  stateSub?: Subscription;
  _data: any;

  titleRestore = 'Wiederherstellen';
  titleDelete = 'Löschen';
  restoreType = '';

  onClickCallback?: (ev: EditCellRendererEvent) => void;

  constructor(
    private stateService: StateService,
    private router: Router
  ) {
  }

  ngOnInit(): void {
    this.isAdmin = this.stateService.isAdmin();
    this.stateSub = this.stateService.adminChange().subscribe((change: isAdminType) => {
      this.isAdmin = change;
    });
  }

  ngOnDestroy(): void {
    this.stateSub = unsub(this.stateSub);
  }

  // gets called once before the renderer is used
  agInit(params: ICellRendererParams): void {
    const cellParams = params?.colDef?.cellRendererParams;

    if (isJsObject(cellParams)) {

      if (cellParams.onClick) {
        this.onClickCallback = cellParams.onClick;
      }

      if (cellParams.canDelete) {
        this.canDelete = cellParams.canDelete;
      }

      if (cellParams.titleDelete) {
        this.titleDelete = cellParams.titleDelete;
      }

      if (cellParams.titleRestore) {
        this.titleRestore = cellParams.titleRestore;
      }

      if (cellParams.restoreType) {
        this.restoreType = cellParams.restoreType;
      }

      this.canDownload = !!cellParams.canDownload;
      this.canRestore = !!cellParams.canRestore;
      this.canEdit = !!cellParams.canEdit;
      this.checkMissing = !!cellParams.checkMissing;

      if (cellParams.url) {
        this.url = cellParams.url;
      }
    }

    if (params.data) {
      this._data = params.data;
      const d = this._data;
      if (d?.id) {
        this.id = d.id;
      }
      if (d.hasOwnProperty('canRestore')) {
        this.canRestore = !!d.canRestore;
      }
      if (d.url) {
        this.url = d.url;
        this.directUrl = true;
      }
      if (this.checkMissing) {
        this.canRestore = this.canRestore && !d.missing;
      }
    }
    if (this.canRestore && this.restoreType && this.canDownload && this.url) {
      this.frCls = 'first-row';
    }
  }

  refresh(params: ICellRendererParams) {
  }

  clicked() {
    if (isFunction(this.onClickCallback)) {
      this.onClickCallback({
        type: EditCellRendererEventType.VIEW,
        data: this._data
      });
      return;
    }
    const url = this.directUrl ? this.url : (this.url + this.id);
    this.id && this.router.navigate([url]);
  }

  clickDelete() {
    isFunction(this.onClickCallback) && this.onClickCallback({
      type: EditCellRendererEventType.DELETE,
      data: this._data
    });
  }

  clickRestore() {
    isFunction(this.onClickCallback) && this.onClickCallback({
      type: EditCellRendererEventType.RESTORE,
      data: this._data
    });
  }
}
